export const FLAG_GETTING_BUSSES_MAINTENANCE_STAY =
  'FLAG_GETTING_BUSSES_MAINTENANCE_STAY';
export const GET_BUSSES_MAINTENANCE_STAY = 'GET_BUSSES_MAINTENANCE_STAY';
export const CLEAR_BUSSES_MAINTENANCE_STAY = 'CLEAR_BUSSES_MAINTENANCE_STAY';
export const FLAG_BUS_MAINTENANCE_STAY = 'FLAG_BUS_MAINTENANCE_STAY';
export const GET_BUS_MAINTENANCE_STAY = 'GET_BUS_MAINTENANCE_STAY';
export const CLEAR_BUS_MAINTENANCE_STAY = 'CLEAR_BUS_MAINTENANCE_STAY';
